export default "__VITE_ASSET__yPZVD9N4__"